import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TicketInfoFromOrderItemPipe } from './pipes/ticket-info-from-order-item.pipe';
import { TicketGraphicBodyComponent } from './components/ticket-graphic/ticket-graphic-body/ticket-graphic-body.component';
import { TicketGraphicFooterComponent } from './components/ticket-graphic/ticket-graphic-footer/ticket-graphic-footer.component';
import { TicketGraphicHeaderComponent } from './components/ticket-graphic/ticket-graphic-header/ticket-graphic-header.component';
import { TicketGraphicDividerComponent } from './components/ticket-graphic/ticket-graphic-divider/ticket-graphic-divider.component';
import { WarningMessageComponent } from './components/warning-message/warning-message.component';
import { KeepHtmlPipe } from './pipes/keep-html.pipe';
import { RunScriptsDirective } from './directives/run-scripts.directive';
import { TicketGraphicSmallBottomComponent } from './components/ticket-graphic/ticket-graphic-small-bottom/ticket-graphic-small-bottom.component';
import { TicketGraphicSmallTopComponent } from './components/ticket-graphic/ticket-graphic-small-top/ticket-graphic-small-top.component';
import { TicketGraphicSmallComponent } from './components/ticket-graphic/ticket-graphic-small/ticket-graphic-small.component';
import { NavModalBaseComponent } from './components/nav-modal-base/nav-modal-base.component';
import { LogoComponent } from './components/logo/logo.component';
import { CheckoutModalComponent } from './components/checkout-modal/checkout-modal.component';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { OpenBankidButtonComponent } from './components/bankid/open-bankid-button/open-bankid-button.component';
import { ExternalBankidButtonComponent } from './components/bankid/external-bankid-button/external-bankid-button.component';
import { QRCodeModule } from 'angularx-qrcode';
import { TicketInfoFromSimpleOrderItemPipe } from './pipes/ticket-info-from-simple-order-item.pipe';





@NgModule({
  declarations: [
    TicketInfoFromOrderItemPipe,
    TicketGraphicBodyComponent,
    TicketGraphicFooterComponent,
    TicketGraphicHeaderComponent,
    TicketGraphicDividerComponent,
    TicketGraphicSmallBottomComponent,
    TicketGraphicSmallTopComponent,
    TicketGraphicSmallComponent,
    WarningMessageComponent,
    NavModalBaseComponent,
    LogoComponent,
    KeepHtmlPipe,
    RunScriptsDirective,
    CheckoutModalComponent,
    PhoneNumberPipe,
    OpenBankidButtonComponent,
    ExternalBankidButtonComponent,
    TicketInfoFromSimpleOrderItemPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    QRCodeModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TicketInfoFromOrderItemPipe,
    TicketInfoFromSimpleOrderItemPipe,
    TicketGraphicBodyComponent,
    TicketGraphicFooterComponent,
    TicketGraphicHeaderComponent,
    TicketGraphicDividerComponent,
    TicketGraphicSmallBottomComponent,
    TicketGraphicSmallTopComponent,
    TicketGraphicSmallComponent,
    WarningMessageComponent,
    NavModalBaseComponent,
    LogoComponent,
    KeepHtmlPipe,
    RunScriptsDirective,
    CheckoutModalComponent,
    PhoneNumberPipe,
    OpenBankidButtonComponent,
    ExternalBankidButtonComponent
  ],
})
export class SharedModule { }
